/**
 * The actual text version of each status
 */
const names = {
  "active": "Active",
  "expired": "Expired",
  "scheduled": "Scheduled"
};

export default {
  /**
   * internal mappings for discount statuses
   */
  Active: "active",
  Expired: "expired",
  Scheduled: "scheduled",

  /**
   * Accessor for the text version of each status
   */
  getName(value) {
    return names[value] || value;
  }
}
